<template>
  <draggable
    :group="{ name: 'g1' }"
    style="min-height: 70px;"
    handle=".block-steps__row-control--drag-handler"
    v-model="val"
    :invertSwap="true"
    :invertedSwapThreshold="0.25"
    @start="drag=true"
    @end="endDrag"
  >
    <div
      v-for="(step, index) in val"
      :key="step.uuid"
      ref="steps"
      @contextmenu="$emit('singleStepMenu', $event)"
    >
      <steps-row ref="stepRows" :step="step" :index="index" :data-index="index" @del="$emit('del', $event)">
        <step-exponent
          ref="stepExponents"
          :steps="val"
          :step="step"
          :index="index"
          :blockId="blockId"
          @refreshActionsPos="refreshActionsPos(index)"
        ></step-exponent>
      </steps-row>
    </div>
  </draggable>
</template>

<script>
export default {
  props: ['blockId', 'value'],
  data () {
    return {
      val: [],
      drag: false
    }
  },
  methods: {
    endDrag () {
      this.drag = false
      this.$refs.steps.forEach(el => {
        el.style = ''
      })
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    },

    async runHooks (hookName) {
      if (!this.$refs.stepExponents) return
      for (let exponent of this.$refs.stepExponents) {
        const step = exponent.$refs.stepElement
        if (!step[hookName] || typeof (step[hookName]) !== 'function') continue
        await step[hookName]()
      }
    },

    refreshActionsPos (index) {
      this.$refs.stepRows[index].calculateRowActionsOffset()
    }
  },
  watch: {
    value: function () {
      if (this.value) this.val = this.value
      else this.val = []
    },

    val: function () {
      this.$emit('input', this.val)
    }
  },
  mounted () {
    if (this.value) this.val = this.value
  }
}
</script>

<style lang="scss">
</style>
